import { CoreStore } from "Stores/RESTStore/CoreStore";
import { FetchError } from "General/ErrorTypes";
import { ArgsProps } from "antd/lib/notification";
import { notificationInstance } from "App";
// import { notification as notificationInstance } from "antd";

// notificationInstance.config({
//   getContainer: () => document.getElementById("root"),
// });

const NOTIFICATION_TEST_IDS = {
  success: "app-notification-success",
  error: "app-notification-error",
  warning: "app-notification-warning",
  info: "app-notification-info",
} as const;

export function notificationSuccess(title: string | JSX.Element, message: string | JSX.Element, testId?: string) {
  notificationInstance.success({
    title: title,
    description: message,
    className: `notification-success`,
    props: { "data-testid": testId || NOTIFICATION_TEST_IDS.success },
  });
}

export function notificationError(
  title: string | JSX.Element,
  message: string | JSX.Element,
  persist?: boolean,
  testId?: string
) {
  notificationInstance.error({
    title: title,
    description: message,
    className: `notification-error`,
    duration: persist ? 0 : 4.5,
    props: { "data-testid": testId || NOTIFICATION_TEST_IDS.error },
  });
}

type NotificationOptions = Omit<ArgsProps, "title" | "message">;
export function notificationWarning(
  title: string | JSX.Element,
  message: string | JSX.Element,
  opts?: NotificationOptions,
  testId?: string
) {
  const notificationProps = { "data-testid": testId || NOTIFICATION_TEST_IDS.warning };
  if (opts?.props) {
    Object.assign(notificationProps, opts.props);
  }
  notificationInstance.warning({
    title: title,
    description: message,
    className: `notification-warning`,
    props: notificationProps,
    ...opts,
  });
}

// tslint:disable-next-line:max-line-length
export function notificationInfo(
  title: string | JSX.Element,
  message: string | JSX.Element,
  duration?: number,
  testId?: string
) {
  notificationInstance.info({
    title: title,
    description: message,
    className: `notification-info`,
    duration: duration,
    props: { "data-testid": testId || NOTIFICATION_TEST_IDS.info },
  });
}

export function notificationStoreError(store: CoreStore) {
  if ((store as CoreStore).stateError) {
    notificationError(
      `${(store.stateError as FetchError).error.status} Error`,
      (store.stateError as FetchError).data.message
    );
  }
}

export function notImplemented() {
  return notificationError("Error", "Not Implemented");
}
